import { useState } from 'react'
import { authApi } from '../lib/api'
import { LogoMark } from './Shared'

export default function AuthView({ onAuthed, notice }) {
  const [mode, setMode] = useState('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  async function submit(event) {
    event.preventDefault()
    if (busy) return
    if (!email.trim() || !password) {
      setError('请输入邮箱和密码')
      return
    }
    setBusy(true)
    setError('')
    try {
      const result = mode === 'login'
        ? await authApi.login(email.trim(), password)
        : await authApi.register(email.trim(), password)
      onAuthed(result.email)
    } catch (err) {
      setError(err.message || '操作失败，请稍后再试')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <LogoMark size={40} />
          <div>
            <h1>页屿</h1>
            <small>PAGE ISLE</small>
          </div>
        </div>
        <p className="auth-sub">登录后使用书架：你的卡片、笔记与版本记录会实时保存到云端，换一台设备也能接着写。</p>

        {notice ? <p className="auth-notice">{notice}</p> : null}

        <div className="auth-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'login'}
            className={mode === 'login' ? 'auth-tab is-active' : 'auth-tab'}
            onClick={() => { setMode('login'); setError('') }}
          >
            登录
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'register'}
            className={mode === 'register' ? 'auth-tab is-active' : 'auth-tab'}
            onClick={() => { setMode('register'); setError('') }}
          >
            注册账号
          </button>
        </div>

        <div className="auth-field">
          <label htmlFor="auth-email">邮箱</label>
          <input
            id="auth-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@example.com"
          />
        </div>
        <div className="auth-field">
          <label htmlFor="auth-password">密码</label>
          <input
            id="auth-password"
            type="password"
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder={mode === 'register' ? '至少 6 位' : '请输入密码'}
          />
        </div>

        <p className="auth-error">{error}</p>

        <button type="submit" className="auth-submit" disabled={busy}>
          {busy ? '请稍候…' : mode === 'login' ? '登录并进入页屿' : '注册并进入页屿'}
        </button>

        <p className="auth-foot">未登录只能看到这个页面；登录后每次保存都会自动生成一个可回朔的版本快照。</p>
      </form>
    </div>
  )
}
